import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getMakes = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return await apiClient.get('car/makes?' + params.toString()); 
};

const getMakeById = async (id: number) => {
  return await apiClient.get(`/makes/${id}`); 
};

const createMake = async (carListingData: any) => {
  return await apiClient.post('/makes', carListingData);
};

const updateMake = async (id: number, carListingData: any) => {
  return await apiClient.patch(`/makes/${id}`, carListingData); 
};

const deleteMake = async (id: number) => {
  return await apiClient.delete(`/makes/${id}`);
};

export default {
  getMakes,
  getMakeById,
  createMake,
  updateMake,
  deleteMake,
};
